export { Result } from 'antd'
export type { ResultProps } from 'antd'
